import brochure from '../../assets/V2/brochure.jpg'
import http from '@/helpers/http'
import Overlay from '@/helpers/Overlay'
import nocturnaIcon from '../../assets/V2/Vida Nocturna.png'
import lugaresIcon from '../../assets/V2/Lugares para visitar.png'
import gastronomiaIcon from '../../assets/V2/Gastronomia.png'
import eventosIcon from '../../assets/V2/Lentes.png'
import turibusIcon from '../../assets/V2/Bus.png'
import turibus from '../../assets/bg/splash.jpg'
import nocturna from '../../assets/bg/nocturna.png'
import lugar from '../../assets/bg/lugares.png'
import gastronomia from '../../assets/bg/gastronomia.png'
import eventos from '../../assets/bg/evento.jpg'
export default {
  name: 'directorio-v-2',
  components: {
    Overlay
  },
  props: [],
  data () {
    return {
      brochure,
      cargando: true,
      lugares: [],
      nocturnaIcon,
      lugaresIcon,
      gastronomiaIcon,
      eventosIcon,
      turibusIcon,
      turibus,
      nocturna,
      lugar,
      gastronomia,
      eventos
    }
  },
  computed: {},
  mounted () {
    this.getDirectorio()
  },
  watch: {
    '$route.params': {
      immediate: true,
      deep: true,
      handler (value) {
        this.getDirectorio()
      }
    }
  },
  methods: {
    getDirectorio () {
      this.cargando = true
      this.lugares = []
      if (this.$route.params.tipo === 'turibus') {
        http.get('/turibus').then(
          res => {
            this.lugares = res.data
            this.cargando = false
          },
          err => {
            console.log(err)
          }
        )
        return
      }
      if (this.$route.params.tipo === 'eventos') {
        http.get('/eventos/' + this.$route.params.ciudad + '/city').then(
          res => {
            this.lugares = res.data
            this.cargando = false
          },
          err => {
            console.log(err)
          }
        )
      } else {
        http.get('/directorio/' + this.$route.params.tipo + '/city/' + this.$route.params.ciudad).then(
          res => {
            this.lugares = res.data
            this.cargando = false
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    verLugar (hash) {
      // alert(hash)
      if (this.$route.params.tipo === 'eventos') {
        this.$router.push({ name: 'evento', params: { hash: hash } })
        return
      }
      if (this.$route.params.tipo === 'turibus') {
        this.$router.push({ name: 'turibus', params: { hash: hash } })
        return
      }
      this.$router.push({ name: 'lugar', params: { hash: hash } })
    },
    cambioCategoria (tipo) {
      this.$router.push({ name: 'directorio', params: { tipo: tipo, ciudad: this.$route.params.ciudad } })
    }
  }
}
